import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import { RowCreateCallBackData } from "../../../../../Types/TablesType";
import { RowCreateCallbackTitle } from "../../../../../Constants/Constants";
import FilterComponent from "../Common/FilterComponent";
import { RowCreateCallBackSubTitle, RowCreateCallBackTableColumns, RowCreateCallBackTableData } from "../../../../../Data/Forms&Table/Tables/DataTables/AdvanceInit";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const RowCreateCallback = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems: RowCreateCallBackData[] = RowCreateCallBackTableData.filter((item: RowCreateCallBackData) => Object.values(item).some((value) => value && value.toString().toLowerCase().includes(filterText.toLowerCase())));
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader headClass="pb-0 card-no-border" title={RowCreateCallbackTitle} span={RowCreateCallBackSubTitle} />
        <CardBody>
          <FilterComponent onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} filterText={filterText} />
          <div className="table-responsive theme-scrollbar">
            <DataTable data={filteredItems} columns={RowCreateCallBackTableColumns} striped={true} pagination className="display custom-scrollbar" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default RowCreateCallback;
